import {
  Field,
  FieldArray,
  FieldArrayRenderProps,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { Card, GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ButtonForAll from "../../components/common/ButtonForAll";
import {
  deleteHotelImage,
  getHotelByID,
  updateHotelImages,
} from "./services/hotel.services";
import ShadowCard from "../../components/common/ShadowCard";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import {
  clearHotelRoomCategoryID,
  setHotelImageDeleteIndex,
  setHotelImageID,
} from "./hotelSlice";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import FormImageUpload from "../../components/formFields/FormImageUpload";
import IconComponent from "../../components/common/IconComponent";
import { MdDelete } from "react-icons/md";
import FormTextField from "../../components/formFields/FormTextField";
import {
  requiredArrayValidator,
  requiredValidator,
} from "../../components/formFields/CommonValidator";
import { setDeleteImageIndex } from "../cms/cmsSlice";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";

const CreateHotelImages = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const HotelID = location.state?.HotelID;
  const HotelDetail = useAppSelector((state) => state.hotel.HotelDetail);
  const hotelImageLoading = useAppSelector(
    (state) => state.hotel.hotelImageLoading
  );
  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [HotelDetail]);

  const handleDeleteImage = (ID: number) => {
    dispatch(openDialog("deleteHotelImage"));
    dispatch(setHotelImageID(ID));
  };

  const handleSubmit = async (values: any) => {
    const ImageData = new FormData();
    const MainImage =
      values?.MainImage && typeof values?.MainImage !== "string"
        ? values.MainImage[0].getRawFile()
        : "";
    const BannerImage =
      values?.BannerImage && typeof values?.BannerImage !== "string"
        ? values.BannerImage[0].getRawFile()
        : "";
    try {
      ImageData.append("ID", values?.ID ? values?.ID : "");
      ImageData.append("MainImage", MainImage);
      ImageData.append("BannerImage", BannerImage);
      values?.Images?.forEach((doc: any) => {
        if (doc?.InnerImages && typeof doc?.InnerImages !== "string") {
          const binaryDoc = doc?.InnerImages[0]?.getRawFile();
          ImageData.append("InnerImages", binaryDoc);
          ImageData.append("InnerImageSrNo", doc?.InnerImageSrNo);
          ImageData.append("InnerImageRemarks", doc?.InnerImageRemarks);
        }
      });

      const res = await dispatch(updateHotelImages(ImageData));
      if (res?.meta?.requestStatus === "fulfilled") {
        if (HotelID) {
          dispatch(getHotelByID(HotelID));
        }
      }
      //   await dispatch(DestinationImageUpload(ImageData));
      //   if (!values?.hotel_room_category_id) {
      //     const insertPayload = {
      //       HotelID: HotelID ? HotelID : null,
      //       RoomCategoryName: values?.RoomCategoryName
      //         ? values?.RoomCategoryName
      //         : "",
      //       IsActive: values?.IsActive === 1,
      //     };
      //     const response = await dispatch(createHotelRoomCategory(insertPayload));
      //     if (response?.meta?.requestStatus === "fulfilled") {
      //       dispatch(getAllHotelRoomCategory({ HotelID: HotelID }));
      //       dispatch(getAllActiveHotelRoomCategory({ HotelID: HotelID }));
      //     }
      //   } else {
      //     const updatePayload = {
      //       ID: values?.hotel_room_category_id
      //         ? values?.hotel_room_category_id
      //         : null,
      //       HotelID: HotelID ? HotelID : null,
      //       RoomCategoryName: values?.RoomCategoryName
      //         ? values?.RoomCategoryName
      //         : "",
      //       IsActive: values?.IsActive === 1,
      //     };
      //     const response = await dispatch(updateHotelRoomCategory(updatePayload));
      //     if (response?.meta?.requestStatus === "fulfilled") {
      //       dispatch(getAllHotelRoomCategory({ HotelID: HotelID }));
      //       dispatch(getAllActiveHotelRoomCategory({ HotelID: HotelID }));
      //     }
      //   }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  return (
    <>
      <DeleteHotelRoomCategoryDialog />
      <Form
        key={formKey}
        initialValues={HotelDetail}
        onSubmit={handleSubmit}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <ShadowCard
              style={{
                padding: 10,
                marginBottom: 10,
                marginTop: 10,
              }}
            >
              <GridLayout
                cols={[{ width: "100%" }]}
                style={{ marginBottom: 20 }}
              >
                <GridLayoutItem>
                  <Typography.h4 className="text-dark">
                    {"Hotel Images"}
                  </Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem>
                  <GridLayout
                    style={{ marginRight: 20 }}
                    gap={{ rows: 0, cols: 10 }}
                    cols={[
                      { width: "33.33%" },
                      { width: "33.33%" },
                      { width: "33.33%" },
                    ]}
                  >
                    <GridLayoutItem style={{ marginTop: 20 }}>
                      <Field
                        justifyContent="start"
                        name={`MainImage`}
                        label="Main Image"
                        type="file"
                        accept="image/*"
                        alternateName="Main Image"
                        component={FormImageUpload}
                        validator={requiredArrayValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem style={{ marginTop: 20 }}>
                      <Field
                        justifyContent="start"
                        name={`BannerImage`}
                        label="Banner Image"
                        type="file"
                        accept="image/*"
                        alternateName="Banner Image"
                        component={FormImageUpload}
                        validator={requiredArrayValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem style={{ marginTop: 20 }} colSpan={3}>
                      <FieldArray
                        formRenderProps={formRenderProps}
                        component={HotelImageArray}
                        name="Images"
                      />
                    </GridLayoutItem>
                    <GridLayoutItem
                      colSpan={3}
                      style={{ textAlign: "end", marginTop: 20 }}
                    >
                      <ButtonForAll
                        label={
                          formRenderProps.valueGetter("hotel_room_category_id")
                            ? "Update"
                            : "Add"
                        }
                        disabled={hotelImageLoading}
                        type="submit"
                      />
                      <Button
                        style={{ marginLeft: 10 }}
                        fillMode={"outline"}
                        themeColor={"primary"}
                        type="button"
                        onClick={() => {
                          setFormKey(formKey + 1);
                        }}
                      >
                        Clear
                      </Button>
                    </GridLayoutItem>
                    {HotelDetail?.HotelImages &&
                      HotelDetail?.HotelImages?.length > 0 && (
                        <GridLayoutItem colSpan={3} className="mt-3">
                          <div className="card shadow-sm border-0">
                            {HotelDetail?.HotelImages?.length > 0 && (
                              <div
                                className="card-body p-2 pt-3 pe-3"
                                style={{
                                  background: "#f8f9fa",
                                  borderRadius: "8px",
                                  border: "1px solid #e0e0e0",
                                }}
                              >
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                  <h5
                                    className="mb-0"
                                    style={{
                                      color: "#2c3e50",
                                      fontWeight: "600",
                                      fontSize: "1.1rem",
                                    }}
                                  >
                                    Uploaded Images
                                  </h5>
                                  <span className="badge bg-kendo-primary rounded-pill">
                                    {HotelDetail?.HotelImages?.length || 0}{" "}
                                    files
                                  </span>
                                </div>

                                <div className="d-flex flex-wrap gap-3">
                                  {HotelDetail?.HotelImages?.map(
                                    (image: any) => (
                                      <div
                                        key={image.ID}
                                        className="position-relative"
                                        style={{
                                          width: "150px",
                                          transition: "all 0.3s ease",
                                        }}
                                      >
                                        <div className="card h-100 border-0 shadow-sm overflow-hidden">
                                          <div className="ratio ratio-1x1 bg-light overflow-hidden">
                                            <div
                                              style={{
                                                position: "absolute",
                                                width: "100%",
                                                height: "auto",
                                                display: "flex",
                                                justifyContent: "space-between",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  position: "relative",
                                                  padding: "5px 10px",
                                                  background: "#174583",
                                                  color: "#fff",
                                                  zIndex: "1",
                                                  borderRadius: "0 0 5px",
                                                }}
                                              >
                                                {image?.InnerImageSrNo}
                                              </span>
                                              <Button
                                                themeColor={"error"}
                                                fillMode={"solid"}
                                                style={{
                                                  position: "relative",
                                                  padding: "5px 10px",
                                                  width: 30,
                                                  height: 30,

                                                  color: "#fff",
                                                  zIndex: "1",
                                                  borderRadius: "0 0 0 5px",
                                                }}
                                                onClick={() =>
                                                  handleDeleteImage(image.ID)
                                                }
                                              >
                                                <IconComponent
                                                  icon={MdDelete}
                                                  className="absolute-position fs-5"
                                                />
                                              </Button>
                                            </div>
                                            <img
                                              className="img-fluid object-fit-cover"
                                              src={image.InnerImages}
                                              alt="Uploaded document"
                                              style={{
                                                cursor: "pointer",
                                                transition: "transform 0.3s",
                                              }}
                                              onMouseEnter={(e) =>
                                                (e.currentTarget.style.transform =
                                                  "scale(1.05)")
                                              }
                                              onMouseLeave={(e) =>
                                                (e.currentTarget.style.transform =
                                                  "scale(1)")
                                              }
                                              onClick={() =>
                                                window.open(
                                                  `${image.InnerImages}`,
                                                  "_blank"
                                                )
                                              }
                                            />
                                          </div>
                                          <div className="card-footer p-2 bg-white border-0">
                                            <p className="fw-600 m-0">{image?.InnerImageRemarks}</p>
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </GridLayoutItem>
                      )}
                  </GridLayout>
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
          </FormElement>
        )}
      />
    </>
  );
};

const DeleteHotelRoomCategoryDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const location = useLocation();
  const HotelID = location.state?.HotelID;

  const HotelImageID = useAppSelector((state) => state.hotel.HotelImageID);

  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteHotelImage(ID));
      if (response.meta.requestStatus === "fulfilled") {
        if (HotelID) {
          dispatch(getHotelByID(HotelID));
        }
        dispatch(closeDialog());
        dispatch(clearHotelRoomCategoryID());
      } else {
        if (HotelID) {
          dispatch(getHotelByID(HotelID));
        }
        dispatch(closeDialog());
        dispatch(clearHotelRoomCategoryID());
      }
    }
  };
  return (
    <>
      {dialogName === "deleteHotelImage" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Image?"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Image?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(HotelImageID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

const HotelImageArray = (fieldArrayRenderProps: FieldArrayRenderProps) => {
  const dispatch = useAppDispatch();
  const HotelImageDeleteIndex = useAppSelector(
    (state) => state.hotel.HotelImageDeleteIndex
  );

  const dialogName = useAppSelector((state) => state.dialog.dialogName);

  const pushElementInarray = React.useCallback(() => {
    fieldArrayRenderProps.onPush({
      value: {
        InnerImages: "",
        InnerImageSrNo: "",
        InnerImageRemarks: "",
      },
    });
  }, [fieldArrayRenderProps]);

  const handleOpenDeleteDialog = (index: number) => {
    dispatch(openDialog("delete-hotel-image"));
    dispatch(setDeleteImageIndex(index));
  };
  const handleDeleteAction = React.useCallback(
    async (index: number) => {
      fieldArrayRenderProps.onRemove({ index: index });
      dispatch(closeDialog());
      dispatch(setHotelImageDeleteIndex(-1));
    },
    [fieldArrayRenderProps]
  );

  return (
    <>
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography.h4>Images Upload</Typography.h4>

          <Button
            fillMode={"solid"}
            themeColor={"primary"}
            onClick={pushElementInarray}
            type="button"
          >
            Add New Image
          </Button>
        </GridLayoutItem>
        {dialogName === "delete-hotel-image" && (
          <AppDialog>
            <>
              <Typography.h5>{"Delete Image"}</Typography.h5>
              <GridLayout>
                <GridLayoutItem>
                  <Typography.p>
                    Are you sure you want to delete this?
                  </Typography.p>
                </GridLayoutItem>
                <GridLayoutItem
                  style={{
                    display: "flex",
                    justifyContent: "end",
                  }}
                >
                  <DialogCloseButton themeColor="error" />
                  <Button
                    fillMode={"solid"}
                    themeColor={"error"}
                    onClick={() => handleDeleteAction(HotelImageDeleteIndex)}
                    type="button"
                  >
                    Delete
                  </Button>
                </GridLayoutItem>
              </GridLayout>
            </>
          </AppDialog>
        )}
        <GridLayoutItem>
          <GridLayout
            style={{ marginRight: 10 }}
            cols={[{ width: "50%" }, { width: "50%" }]}
            gap={{ rows: 0, cols: 10 }}
          >
            {fieldArrayRenderProps.value &&
              fieldArrayRenderProps.value.length > 0 &&
              fieldArrayRenderProps.value.map((Images: any, index: number) => (
                <GridLayoutItem key={index}>
                  <Card className="fieldarray-card-imageArray">
                    <GridLayout
                      style={{ marginRight: 20 }}
                      gap={{ rows: 0, cols: 10 }}
                      cols={[
                        { width: "40%" },
                        { width: "40%" },
                        { width: "20%" },
                      ]}
                    >
                      <GridLayoutItem colSpan={3}>
                        <Field
                          imageWidth={60}
                          imageHeight={60}
                          name={`Images.${index}.InnerImages`}
                          label="Image"
                          type="file"
                          accept="image/*"
                          acceptFileTypesMessage="Only JPG, PNG, and WEBP images are accepted."
                          component={FormImageUpload}
                          validator={requiredArrayValidator}
                          astrike={true}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={3} className="d-flex gap-2">
                        <Field
                          wrapperClassName="w-25 right-aligned-field"
                          name={`Images.${index}.InnerImageSrNo`}
                          label="Sr. No."
                          placeholder="0"
                          format="n0"
                          component={FormNumericTextField}
                          validator={requiredValidator}
                          astrike={true}
                          max={10000}
                        />
                        <Field
                          wrapperClassName="w-100"
                          name={`Images.${index}.InnerImageRemarks`}
                          label="Title"
                          placeholder="Title"
                          validator={requiredValidator}
                          astrike={true}
                          component={FormTextField}
                        />
                        <div
                          style={{
                            marginTop: 34,
                            display: "flex",
                            justifyContent: "end",
                            gap: 10,
                          }}
                        >
                          <Button
                            onClick={() => handleOpenDeleteDialog(index)}
                            // disabled={fieldArrayRenderProps.value.length === 1}
                            title={"Delete Image"}
                            fillMode={"solid"}
                            themeColor={"error"}
                            type="button"
                            size={"small"}
                            style={{ width: 32, height: 32 }}
                          >
                            <IconComponent
                              icon={MdDelete}
                              className="absolute-position fs-5"
                            />
                          </Button>
                        </div>
                      </GridLayoutItem>
                    </GridLayout>
                  </Card>
                </GridLayoutItem>
              ))}
          </GridLayout>
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

export default CreateHotelImages;
